import { render } from "./TabNav.vue?vue&type=template&id=1346c85a"
import script from "./TabNav.vue?vue&type=script&lang=js"
export * from "./TabNav.vue?vue&type=script&lang=js"

import "./TabNav.vue?vue&type=style&index=0&id=1346c85a&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__